var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationCapDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.519 16.424v12.558c0 2.857-6.5 7.768-14.516 7.768-8.017 0-14.517-4.91-14.517-7.768V16.424H39.52z",
    fill: "url(#y1di04liua)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.519 26.005v2.977c0 2.857-6.5 7.768-14.516 7.768-8.017 0-14.517-4.911-14.517-7.768v-2.977c0 2.856 6.5 7.767 14.517 7.767 8.016 0 14.516-4.91 14.516-7.767z",
    fill: "#47506B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.519 16.424v1.873L25.412 24.63a1 1 0 0 1-.82 0l-14.106-6.333v-1.873H39.52z",
    fill: "#576183"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41 22.757a1 1 0 0 1-.82 0L2.034 12.633c-.788-.354-.788-1.472 0-1.825L24.59.684a1 1 0 0 1 .819 0l22.557 10.124c.788.353.788 1.471 0 1.825L25.41 22.757z",
    fill: "url(#so859c88yb)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.937 31.572V15.889l-17.081-3.306a.816.816 0 0 1-.528-.362.926.926 0 0 1-.133-.656.885.885 0 0 1 .338-.565.777.777 0 0 1 .613-.143l17.742 3.453a.798.798 0 0 1 .479.301.901.901 0 0 1 .182.562v16.399a.895.895 0 0 1-.236.61.78.78 0 0 1-.57.253.781.781 0 0 1-.57-.253.895.895 0 0 1-.236-.61z",
    fill: "url(#i9rp0uwn4c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m44.62 33.298.541 3.452h-4.839l.54-3.452c.072-.478.301-.913.645-1.227a1.83 1.83 0 0 1 1.235-.486c.452 0 .89.172 1.234.486s.573.749.645 1.227z",
    fill: "url(#fj2j1cbied)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y1di04liua",
    x1: 25.003,
    y1: 16.424,
    x2: 25.003,
    y2: 36.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9197AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47506B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "so859c88yb",
    x1: 25,
    y1: 0.5,
    x2: 25,
    y2: 22.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47506B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959CB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i9rp0uwn4c",
    x1: 33.872,
    y1: 32.426,
    x2: 33.872,
    y2: 10.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj2j1cbied",
    x1: 42.742,
    y1: 36.75,
    x2: 42.742,
    y2: 31.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB79"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCapDark);
export default __webpack_public_path__ + "static/media/graduation-cap-dark.539495a89ea4b0c4d621f93b9dc0c2dc.svg";
export { ForwardRef as ReactComponent };